module.exports = __webpack_public_path__ + "img/切换1.f70f07a4.svg";